import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDocumentDocx = () => {
  return (
    <g>
      <path d="M14.4.2H5.1c-.2 0-.4.1-.5.2L1.1 3.9c-.1.1-.2.3-.2.5V15c0 .4.3.7.7.7h12.7c.4 0 .7-.3.7-.7V.9c0-.3-.2-.7-.6-.7zm-9.5 2v2h-2l2-2zm8.7 12.1H2.4V5.6h3.2c.4 0 .7-.3.7-.7V1.7h7.3v12.6z" />
      <path d="M3.4 9.9h.9c.7 0 1.2.4 1.2 1.2s-.5 1.2-1.2 1.2h-.9V9.9zm.6 1.9h.3c.4 0 .6-.2.6-.7s-.3-.7-.6-.7H4v1.4zM8.1 11.1c0 .8-.5 1.3-1.2 1.3s-1.2-.5-1.2-1.3.5-1.3 1.2-1.3 1.2.5 1.2 1.3zm-1.7 0c0 .5.2.8.5.8s.5-.3.5-.8-.1-.8-.4-.8c-.4 0-.6.3-.6.8zM9.4 9.8c.5 0 .8.2 1 .7l-.5.2c0-.2-.2-.4-.4-.4-.3 0-.5.3-.5.8s.2.8.5.8c.2 0 .4-.2.4-.4l.6.2c-.1.4-.5.7-1 .7-.7 0-1.2-.5-1.2-1.3s.4-1.3 1.1-1.3zM11.7 11.5l-.5.8h-.7l.8-1.3-.8-1.2h.7l.5.7.5-.7h.7l-.8 1.2.8 1.3h-.7l-.5-.8z" />
    </g>
  );
};

export default withIcon(IconDocumentDocx);
